<template>

  <body class="hold-transition login-page">
    <div class="login-box">
      <!-- <div class="login-logo"> -->
      <div class="login-banner" :class="$config.theme">
        <h2>{{ $config.app_name }}</h2>
        <p>{{ $config.app_address }}</p>
      </div>
      <div class="card">
        <div class="card-body login-card-body">
          <p class="login-box-msg lead">লগইন করুন</p>

          <form>
            <label>ইমেইল</label>
            <div class="input-group mb-3">

              <input v-model="email" class="form-control login-input" placeholder="আপনার ইমেইল লিখুন...">
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fas fa-envelope"></span>
                </div>
              </div>
            </div>
            <label>পাসওয়ার্ড</label>
            <div class="input-group mb-4">
              <input v-model="password" type="password" class="form-control login-input" placeholder="আপনার পাসওয়ার্ড লিখুন...">
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fas fa-lock"></span>
                </div>
              </div>
            </div>
          </form>
          <div class="row">
            <!-- /.col -->
            <div class="col">
              <button type="submit" @click="getData" :class="$config.theme" class="btn btn-primary btn-block">লগইন
                করুন</button>
            </div>
            <!-- /.col -->
          </div>
          <div class="row mt-3">
            <!-- /.col -->
            <div class="col">
              <button type="submit" @click="resetPassword" class="btn btn-danger btn-block">পাসওয়ার্ড রিসেট
                করুন</button>
            </div>
            <!-- /.col -->
          </div>
        </div>
        <!-- /.login-card-body -->
      </div>
      {{ response }}
    </div>
    <!-- /.login-box -->
  </body>
</template>

<script>

//import axios from "axios";
import { auth, firebase } from "@/firebase";
import { mapGetters } from 'vuex';
export default {
  name: "LoginComponent",
  data() {
    return {
      error: false,
      email: "",
      password: "",
      response: "",
      customerTitle: "",
      welcomeMessage: "",
      newMsg: ""
    }
  },
  methods: {
    async txt() {
      const response = await fetch('/info.txt')
      this.customerTitle = await response.text()

    },
    async resetPassword() {
      try {
        // Sends a password reset email
        await auth.sendPasswordResetEmail(this.email);
        // Handle success (e.g., show a success message to the user)
        console.log('Password reset email sent successfully');
        this.$swal('পাসওয়ার্ড রিসেট ইমেল সফলভাবে পাঠানো হয়েছে ' + this.email, "success");
      } catch (error) {
        // Handle errors here (e.g., show an error message)
        console.error('Error sending password reset email:', error);
        alert('Error sending password reset email: ' + error.message);
      }
    },
    async getData() {
      this.$swal.showLoading()
      try {
        // 1. Authenticate the user
        // Assuming you're using Firebase Authentication, replace this with your actual login logic
        const userCredential = await auth.signInWithEmailAndPassword(this.email, this.password);
        console.log("userCredential")
        console.log(userCredential)
        const user = userCredential.user;
        this.$swal.close()
        this.$swal('লগইন সফল! ');
        // 2. Store user information in Vuex
        user.getIdToken().then((data) => {
          console.log("After Login")
          console.log(data)
          firebase.analytics().logEvent("sign_in", data)
          localStorage.setItem('authToken', data);
          this.$store.dispatch('login', user);
          console.log(user)
          // 3. Redirect the user to the original destination or a default route (e.g., /dashboard)
          const redirect = this.$route.query.redirect || '/home';
          this.$router.push(redirect);
        }).catch((error) => {
          console.log(error)

        })



      } catch (error) {
        console.error('Login failed:', error);
        this.$swal('ইমেইল অথবা পাসওয়ার্ড ভুল হয়েছে! আবার চেষ্টা করুন... ');
      }
    }
  },
  computed: {
    ...mapGetters({
      config: 'config/config'  // from config module
    }),
    userName() {
      return this.config.userName;
    },
    businessName() {
      return this.config.app_name;
    },
    themeColor() {
      return this.config.themeColor;
    },
    subscriptionExpiry() {
      return this.config.subscriptionExpiry;
    }
  },
  async created() {
    await this.txt();
    console.log("VUE_APP")
    this.newMsg = process.env.VUE_APP_NOT_SECRET_CODE
    console.log(import.meta.env.VITE_API_ENDPOINT)
    console.log("Test")
    console.log(import.meta.env.VITE_PUBLIC_VAR)

  }
}
</script>

<style scoped>
.login-banner {
  text-align: center;
  color: white;
  padding-top: 22px;
  padding-bottom: 4px;
}

.login-banner h2 {
  font-size: 36px;
  margin-bottom: 4px;
}

.login-banner p {
  font-size: 18px;
}

.login-input {
  height: 44px;
  font-size: 18px;
}
</style>